export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20479)">
                <path
                    d="M13.9247 26.7189C13.9668 27.5098 14.6171 28.125 15.4091 28.125H20.5748C21.3715 28.125 22.0239 27.5027 22.0622 26.7069C22.1848 24.1627 22.4458 20.8171 24.045 19.2543C25.583 17.7579 26.4422 15.7468 26.4375 13.6537C26.4375 9.22677 22.6528 5.625 18.0003 5.625C13.3333 5.625 9.62737 9.10228 9.56363 13.5409C9.54552 14.5901 9.74505 15.6324 10.1508 16.6081C10.5565 17.5838 11.1605 18.4738 11.9282 19.2271C13.5264 20.8029 13.7888 24.1669 13.9247 26.7189Z"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M20.25 28.6875C20.25 29.9301 19.2426 30.9375 18 30.9375C16.7574 30.9375 15.75 29.9301 15.75 28.6875"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <line x1="13.5" y1="25.125" x2="22.5" y2="25.125" stroke="black" strokeWidth="1.5" />
                <path d="M6.75 12.375H4.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M29.25 12.0459H31.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7.54688 8.6709L5.95588 7.07991" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M28.4531 8.34082L30.0441 6.74983" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7.54688 15.75L5.95588 17.341" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M28.4531 15.4209L30.0441 17.0119" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19.75 17.375V24.25H16.8125V17.375H19.75Z" stroke="black" />
                <path
                    d="M20.8125 15.125C21.4683 15.125 22 15.6567 22 16.3125C22 16.9683 21.4683 17.5 20.8125 17.5H19.625V16.3125C19.625 15.6567 20.1567 15.125 20.8125 15.125Z"
                    stroke="black"
                />
                <path
                    d="M15.75 15.125C15.0942 15.125 14.5625 15.6567 14.5625 16.3125C14.5625 16.9683 15.0942 17.5 15.75 17.5H16.9375V16.3125C16.9375 15.6567 16.4058 15.125 15.75 15.125Z"
                    stroke="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_1975_20479">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
